const CODE_BLOCK_SPLIT_REGEX = /(```[\s\S]*?```)/g;
const INVISIBLE_CHAR_REGEX = /[\u200B\u200C\u200D\uFEFF]/g;

const isObject = (value) => value !== null && typeof value === 'object';

const fromArrayContent = (parts = []) => {
  return parts
    .map((part) => {
      if (typeof part === 'string') return part;
      if (!isObject(part)) return '';

      if (typeof part.text === 'string') return part.text;
      if (typeof part.content === 'string') return part.content;
      if (typeof part.value === 'string') return part.value;
      if (Array.isArray(part.text)) return fromArrayContent(part.text);

      return '';
    })
    .filter(Boolean)
    .join('\n');
};

export const extractTextFromAiContent = (content) => {
  if (content === null || content === undefined) return '';

  if (typeof content === 'string') {
    return content;
  }

  if (typeof content === 'number' || typeof content === 'boolean') {
    return String(content);
  }

  if (Array.isArray(content)) {
    return fromArrayContent(content);
  }

  if (isObject(content)) {
    if (typeof content.text === 'string') return content.text;
    if (typeof content.content === 'string') return content.content;
    if (Array.isArray(content.content)) return fromArrayContent(content.content);
    if (typeof content.value === 'string') return content.value;

    try {
      return JSON.stringify(content, null, 2);
    } catch (error) {
      return String(content);
    }
  }

  return String(content);
};

const normalizeOutsideCodeBlocks = (text, normalizer) => {
  return text
    .split(CODE_BLOCK_SPLIT_REGEX)
    .map((segment) => (segment.startsWith('```') ? segment : normalizer(segment)))
    .join('');
};

const parseQuotedJsonString = (text) => {
  const trimmed = text.trim();
  if (!(trimmed.startsWith('"') && trimmed.endsWith('"'))) {
    return text;
  }

  try {
    const parsed = JSON.parse(trimmed);
    return typeof parsed === 'string' ? parsed : text;
  } catch (error) {
    return text;
  }
};

const decodeEscapedWhitespaceWhenLikely = (text) => {
  const escapedNewlines = (text.match(/\\n/g) || []).length;
  const hasActualNewline = text.includes('\n');

  // Only decode escaped newlines/tabs when payload looks like serialized text.
  // This avoids breaking normal strings like file paths with a single "\\n" token.
  if (!hasActualNewline && escapedNewlines >= 2) {
    return text
      .replace(/\\r\\n/g, '\n')
      .replace(/\\n/g, '\n')
      .replace(/\\t/g, '\t')
      .replace(/\\r/g, '\n');
  }

  return text;
};

export const normalizeAiMarkdown = (content) => {
  let text = extractTextFromAiContent(content);
  text = parseQuotedJsonString(text);
  text = decodeEscapedWhitespaceWhenLikely(text);

  text = text
    .replace(/\r\n/g, '\n')
    .replace(/\r/g, '\n')
    .replace(INVISIBLE_CHAR_REGEX, '');

  text = normalizeOutsideCodeBlocks(text, (segment) => segment.replace(/\n{3,}/g, '\n\n'));

  return text.trim();
};

export default normalizeAiMarkdown;
